import { render, staticRenderFns } from "./SavitarnaDokumentai.vue?vue&type=template&id=6fad432b&scoped=true&"
import script from "./SavitarnaDokumentai.vue?vue&type=script&lang=js&"
export * from "./SavitarnaDokumentai.vue?vue&type=script&lang=js&"
import style0 from "./SavitarnaDokumentai.vue?vue&type=style&index=0&id=6fad432b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fad432b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VContainer,VDataTable})
